import apiClient from "@/axios.js";
import endpoints from "@/endpoints";
import axios from "axios";
const PREPR_API = process.env.VUE_APP_PREPR_API;

export async function getArchaicResult(barcode) {
  const { data } = await apiClient.get(endpoints.archaicResult(barcode));
  return data;
}

export async function getArchaicIntroduction() {
  const res = await axios.post(PREPR_API, {
    query: `{
              CommonModel (slug: "neanderthals-introduction") { 
                      title
                      heading
                      text
                      main_image { 
                              url
                      }
                      right_section {
                              title
                              heading
                              main_image {
                                      url
                              }
                              text
                              button_text
                      }
              }
      }`,
  });
  return res.data.data.CommonModel;
}

export async function getArchaicReferences() {
  const res = await axios.post(PREPR_API, {
    query: `{
        CommonModel (slug: "neanderthal-references") { 
            title
            heading
            text
            main_image { 
                    url
            }
          }
        }`,
  });
  return res.data.data.CommonModel;
}

export async function getArchaicTraits() {
  const res = await axios.post(PREPR_API, {
    query: `{
        CommonUpgrade (slug: "neanderthal-traits") { 
          heading
          title
          content {
                  title
                  heading
                  text
                  image {
                          url
                  }
                }
            }
         }`,
  });
  return res.data.data.CommonUpgrade;
}

export async function getArchaicUpgrade() {
  const res = await axios.post(PREPR_API, {
    query: `{
      CommonUpgrade (slug: "neanderthal-upgrade") { 
        heading
        title
        content {
            title
            heading
            image {
              url
            }
            text
            button_text
          }
          description
          faqs {
            question
            answer
          }
        }
      }`
  });
  return res.data.data.CommonUpgrade;
}

export async function getArchaicUnlock() {
  const res = await axios.post(PREPR_API, {
    query: `{
      CommonUnlock (slug: "unlock-neanderthals") { 
          title
          banner { 
                  title
                  heading
                  image { 
                          url
                  }
                  text
                  button_text
          }
          description { 
                  title
                  heading
                  image { 
                          url
                  }
                  text
          }
        }
      }`
  });
  return res.data.data.CommonUnlock;
}

export async function getArchaicUnderstanding() {
  const { data } = await apiClient.get(endpoints.archaicCms("understanding_your_results"));
  return data;
}

export async function getArchaicResultsCard() {
  const { data } = await apiClient.get(endpoints.archaicCms("archaic_results_card"));
  return data;
}

export async function getArchaicMapCard() {
  const { data } = await apiClient.get(endpoints.archaicCms("archaic_map_card"));
  return data;
}

export async function getArchaicTraitsCard() {
  const { data } = await apiClient.get(endpoints.archaicCms("archaic_traits_card"));
  return data;
}

export async function getArchaicNeanderthal() {
  const { data } = await apiClient.get(endpoints.archaicCms("neanderthal"));
  return data;
}

export async function getArchaicDenisovan() {
  const { data } = await apiClient.get(endpoints.archaicCms("denisovan"));
  return data;
}

export async function getArchaicTrait(trait) {
  const { data } = await apiClient.get(endpoints.archaicCms(trait));
  return data;
}

export async function getClosestSampleInfo(sample) {
  const { data } = await apiClient.get(endpoints.archaicCms(sample));
  return data;
}
